import { Container } from './/Container'

import Certification from './Certification'


// Translation
import { useTranslation } from "react-i18next";

import {dataFR} from "../assets/data/fr"
import {dataEN} from "../assets/data/en"
import {dataNL} from "../assets/data/nl"



export const Quality = (props) => {

    const { i18n } = useTranslation();



    let data = dataFR;
    if (i18n.language === "fr") {
      data = dataFR;
    } else if (i18n.language === "en") {
      data = dataEN;
    } else if (i18n.language ==="nl"){
      data = dataNL;
    }
  


    return (
        <Container className="flex flex-wrap flex-col-reverse mb-20 md:gap-10 lg:flex-nowrap lg:flex-row">
           <div
                className={`flex items-center justify-center w-full lg:w-1/2 ${
          props.imgPos === "right" ? "lg:order-1" : ""
        }`}>
                <div>
                    <Certification />
                </div>
            </div>


            <div
                className={`flex flex-wrap items-center w-full lg:w-1/2 p-8`}>
                <div>
                    <div className="flex flex-col w-full mt-4">
                        <h3 className="max-w-2xl mt-3 text-3xl font-bold leading-snug tracking-tight text-gray-800 lg:leading-tight lg:text-4xl dark:text-white">
                            {data.quality.title}
                        </h3>
                        <p className="max-w-2xl py-4 text-lg leading-normal text-gray-500 lg:text-xl xl:text-xl dark:text-gray-300 white-space: pre-wrap">
                            {data.quality.desc}
                        </p>
                        <div className="w-full mt-5">
                            <div className="flex items-start mt-8 space-x-3">
                                <ul className="mt-1 text-gray-500 dark:text-gray-400 list-disc ">
                                    {data.quality.controlList.map((list, index) =>(
                                        <li key={index}>{list}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </Container>
    )
}

